import React from 'react';
import '../CSS/bootstrap/custom/html5flx/v1/css/custom-body.css';
import '../CSS/ContainerPreview.css';

interface ContainerProps {
  children: React.ReactNode;
  className?: string; // Optional additional classes
}

const ContainerPreview: React.FC<ContainerProps> = ({
  children,
  className,
}) => {
  return (
    <div
      className={`container ${className || ''}`}
      style={{
        margin: '0 auto' /* Center the container horizontally */,
        padding: '30px 150px' /* Default padding for larger screens */,
        overflow: 'visible',
        maxWidth: '1200px' /* Add a max-width for larger screens */,
      }}
    >
      {children}
    </div>
  );
};

export default ContainerPreview;
